import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'

import {
  getCustomFieldById,
  getAllCustomFields,
  addCustomField,
  removeCustomField,
  updateCustomField,
} from './api'
import type { CustomFieldOption } from '@sales-center/common'
import type { StoreData } from '../reducers/typings'
import { getFieldOptions, removeOptions } from './utils'

export const customFieldOptionsAdapter =
  createEntityAdapter<CustomFieldOption>()

export const customFieldOptionsInitialState =
  customFieldOptionsAdapter.getInitialState()

const customFieldOptionsSlice = createSlice({
  name: 'customFieldOptionsSlice',
  initialState: customFieldOptionsInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCustomFieldById.fulfilled, (state, { payload }) => {
      customFieldOptionsAdapter.setMany(state, getFieldOptions(payload))
    })

    builder.addCase(getAllCustomFields.fulfilled, (state, { payload }) => {
      const options = payload.flatMap(getFieldOptions)
      customFieldOptionsAdapter.setAll(state, options)
    })

    builder.addCase(addCustomField.fulfilled, (state, { payload }) => {
      customFieldOptionsAdapter.addMany(state, getFieldOptions(payload))
    })

    builder.addCase(updateCustomField.fulfilled, (state, { payload }) => {
      removeOptions(state, payload.id)
      customFieldOptionsAdapter.addMany(state, getFieldOptions(payload))
    })

    builder.addCase(removeCustomField.fulfilled, (state, { meta: { arg } }) => {
      removeOptions(state, arg)
    })
  },
})

export const customFieldOptionsReducer = customFieldOptionsSlice.reducer

export const { selectAll: selectAllCustomFieldOptions } =
  customFieldOptionsAdapter.getSelectors<StoreData>(
    (state) => state.customFieldOptions,
  )
